import axiosHttp from "./interceptor.service";

const addPayroll = (data) => {
    return axiosHttp.post("/lmt/payroll", data);
};

const getPayrollByEmployeeId = (employeeId) => {
    return axiosHttp.get(`/lmt/payroll/${employeeId}`);
};

const uploadPayroll = async (formData) => {
    return axiosHttp.post("/lmt/payroll/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

const getPayrollByMonth = async (month, year) => {
    return axiosHttp.get(`/lmt/payroll/month/${month}/${year}`);
};

const downloadPayroll = async (month, year) => {
    return axiosHttp.get(`/lmt/payroll/download`, {
        params: { month, year },
        responseType: 'blob',
    });
};

const deletePayrollByMonth = async (month, year) => {
    return axiosHttp.delete(`/lmt/payroll/month/${month}/${year}`);
};

const updatePayrollStatus = async (id, status) => {
    return axiosHttp.put(`/lmt/payroll/status/${id}`, { status });
};

const getPayrollFile = async (month, year) => {
    return axiosHttp.get(`/lmt/payroll/file/${month}/${year}`);
};

const downloadPayrollFile = async (fileId) => {
    return axiosHttp.get(`/lmt/payroll/file/download/${fileId}`);
};

export {
    addPayroll,
    getPayrollByEmployeeId,
    uploadPayroll,
    getPayrollByMonth,
    downloadPayroll,
    deletePayrollByMonth,
    updatePayrollStatus,
    getPayrollFile,
    downloadPayrollFile
};
